import React, { useState, useEffect } from 'react';
import {
	Paper,
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableRow,
	TableContainer,
	TablePagination,
	Popover,
	IconButton,
	Menu,
	MenuItem,
	FormControl,
	InputLabel,
	Select,
} from '@material-ui/core';
import CustomButton from '../../../layout/customButton/CustomButton';
import styles from './CoBroker.module.scss';
import { connect } from 'react-redux';
import PhoneIcon from '@material-ui/icons/Phone';
import EmailIcon from '@material-ui/icons/Email';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import CopyToClipboard from 'react-copy-to-clipboard';
import Modal from '../../../layout/modal/Modal';
import AddCoBroker from './addCoBroker/AddCoBroker';
import {
	assignSalesAgentToCoBroker,
	deleteCoBroker,
} from '../../../../api/Siteplan/updateCoBroker.api';

const CoBroker = (props) => {
	const { coBrokers, lots, salesAgents, search } = props;

	const [anchorEl, setAnchorEl] = useState();
	const [anchorMenu, setAnchorMenu] = useState();
	const [contactType, setContactType] = useState('');
	const [contactId, setContactId] = useState('');
	const [moreMenuId, setMoreMenuId] = useState('');
	const [addCoBrokerModal, setAddCoBrokerModal] = useState(false);
	const [editCoBrokerId, setEditCoBrokerId] = useState('');
	const [page, setPage] = useState(0);
	const [rowsPerPage, setRowsPerPage] = useState(5);
	const [filteredCoBrokers, setFilteredCoBrokers] = useState([]);

	useEffect(() => {
		if (coBrokers) {
			setFilteredCoBrokers(
				coBrokers.filter(
					(coBroker) =>
						coBroker.name
							?.toLowerCase()
							.includes(search.toLowerCase()) ||
						coBroker.assignedSalesAgentName
							?.toLowerCase()
							.includes(search.toLowerCase()) ||
						coBroker.email
							?.toLowerCase()
							.includes(search.toLowerCase()) ||
						coBroker.phoneNumber === search
				)
			);
			setPage(0);
		}
	}, [coBrokers, search]);

	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
	};

	const handleClickContactBtn = (event) => {
		setAnchorEl(event.currentTarget);
		setContactType(event.currentTarget.dataset.contact);
		setContactId(event.currentTarget.dataset.id);
	};

	const handleCloseContactPopover = () => {
		setAnchorEl();
		setContactType('');
		setContactId('');
	};

	const handleClickMoreBtn = (event) => {
		setAnchorMenu(event.currentTarget);
		setMoreMenuId(event.currentTarget.dataset.id);
	};

	const handleCloseMoreMenu = () => {
		setAnchorMenu();
	};

	const handleEditCoBroker = (coBrokerId) => {
		openAddCoBrokerModal();
		setEditCoBrokerId(coBrokerId);
		handleCloseMoreMenu();
	};

	const handleDeleteCoBroker = (coBrokerId) => {
		if (coBrokerId) {
			deleteCoBroker(coBrokerId);
		}
		handleCloseMoreMenu();
	};

	const getCoBrokerLot = (coBrokerId) => {
		const filteredLots = lots.filter(
			(lot) => lot.assignedCoBroker && lot.assignedCoBroker === coBrokerId
		);
		if (filteredLots.length > 0) {
			return filteredLots.map((filteredLot) => filteredLot.lot).join();
		} else {
			return '-';
		}
	};

	const openAddCoBrokerModal = () => {
		setEditCoBrokerId('');
		setAddCoBrokerModal(true);
	};

	const closeAddCoBrokerModal = () => {
		setAddCoBrokerModal(false);
	};

	const handleAgentChange = (e, coBrokerId) => {
		assignSalesAgentToCoBroker(e.target.value, coBrokerId);
	};

	const open = Boolean(anchorEl);

	return (
		<Paper className={styles.co_broker}>
			<div className={styles.co_broker_header}>
				<h2 className={styles.co_broker_header_title}>Co-Brokers</h2>
				<CustomButton
					width={166}
					height={42}
					onClick={openAddCoBrokerModal}
				>
					Add Co-Broker
				</CustomButton>
			</div>
			<TableContainer className={styles.co_broker_table}>
				<Table>
					<TableHead>
						<TableCell>Name</TableCell>
						<TableCell>Assigned Lot</TableCell>
						<TableCell>Assigned agent</TableCell>
						<TableCell></TableCell>
					</TableHead>
					<TableBody>
						{filteredCoBrokers
							.slice(
								page * rowsPerPage,
								page * rowsPerPage + rowsPerPage
							)
							.map((coBroker) => {
								return (
									<TableRow key={coBroker.coBrokerId}>
										<TableCell component='th' scope='row'>
											{coBroker.name}
										</TableCell>
										<TableCell component='th' scope='row'>
											{getCoBrokerLot(
												coBroker.coBrokerId
											)}
										</TableCell>
										<TableCell component='th' scope='row'>
											<Select
												variant='outlined'
												className={
													styles.assigned_agent
												}
												value={
													coBroker.assignedSalesAgent
														? coBroker.assignedSalesAgent
														: ''
												}
												onChange={(e) =>
													handleAgentChange(
														e,
														coBroker.coBrokerId
													)
												}
											>
												{salesAgents.map(
													(salesAgent) => (
														<MenuItem
															value={
																salesAgent.salesAgentId
															}
															key={
																salesAgent.salesAgentId
															}
														>
															{
																salesAgent.salesAgentName
															}
														</MenuItem>
													)
												)}
											</Select>
										</TableCell>
										<TableCell
											component='th'
											scope='row'
											align='right'
										>
											<IconButton
												onClick={handleClickContactBtn}
												data-contact='email'
												data-id={coBroker.coBrokerId}
											>
												<EmailIcon
													className={
														styles.contact_btn
													}
												/>
											</IconButton>
											<IconButton
												onClick={handleClickContactBtn}
												data-contact='phone'
												data-id={coBroker.coBrokerId}
											>
												<PhoneIcon
													className={
														styles.contact_btn
													}
												/>
											</IconButton>
											<IconButton
												onClick={handleClickMoreBtn}
												data-id={coBroker.coBrokerId}
											>
												<MoreVertIcon
													className={
														styles.contact_btn
													}
												/>
											</IconButton>
											<Popover
												open={
													open &&
													contactId ===
														coBroker.coBrokerId
												}
												anchorEl={anchorEl}
												onClose={
													handleCloseContactPopover
												}
												anchorOrigin={{
													vertical: 'bottom',
													horizontal: 'center',
												}}
												transformOrigin={{
													vertical: 'top',
													horizontal: 'center',
												}}
											>
												<div
													className={
														styles.contact_popover
													}
												>
													<p>
														{contactType === 'phone'
															? coBroker.phoneNumber
															: contactType ===
															  'email'
															? coBroker.email
															: ''}
													</p>
													<CopyToClipboard
														text={
															contactType ===
															'phone'
																? coBroker.phoneNumber
																: contactType ===
																  'email'
																? coBroker.email
																: ''
														}
														onCopy={
															handleCloseContactPopover
														}
														className={
															styles.copy_btn
														}
													>
														<FileCopyIcon />
													</CopyToClipboard>
												</div>
											</Popover>
											<Menu
												anchorEl={anchorMenu}
												open={
													Boolean(anchorMenu) &&
													moreMenuId ===
														coBroker.coBrokerId
												}
												onClose={handleCloseMoreMenu}
											>
												<MenuItem
													onClick={() => {
														handleEditCoBroker(
															coBroker.coBrokerId
														);
													}}
												>
													Edit
												</MenuItem>
												<MenuItem
													onClick={() =>
														handleDeleteCoBroker(
															coBroker.coBrokerId
														)
													}
												>
													Delete
												</MenuItem>
											</Menu>
										</TableCell>
									</TableRow>
								);
							})}
					</TableBody>
				</Table>
			</TableContainer>
			<TablePagination
				rowsPerPageOptions={[5, 10, 25]}
				component='div'
				count={filteredCoBrokers.length}
				rowsPerPage={rowsPerPage}
				page={page}
				onPageChange={handleChangePage}
				onRowsPerPageChange={handleChangeRowsPerPage}
				labelRowsPerPage={
					<div style={{ color: 'var(--text-high-emphasis)' }}>
						Rows per page
					</div>
				}
				nextIconButtonProps={{
					style: {
						padding: '0px',
					},
				}}
				backIconButtonProps={{
					style: {
						padding: '0px',
						marginLeft: '-10px',
					},
				}}
				SelectProps={{
					style: {
						border: '1px solid var(--text-mid-emphasis)',
						borderRadius: '4px',
						padding: '4px',
						marginRight: '10px',
					},
				}}
			/>
			<div className={styles.add_co_broker_modal}>
				<Modal
					show={addCoBrokerModal}
					close={closeAddCoBrokerModal}
					title='Add Co-Broker'
					wrapperWidth='80%'
				>
					<AddCoBroker
						editCoBrokerId={editCoBrokerId}
						closeAddCoBrokerModal={closeAddCoBrokerModal}
						modalOpen={addCoBrokerModal}
					/>
				</Modal>
			</div>
		</Paper>
	);
};

const mapStateToProps = (state) => ({
	coBrokers: state.siteplanManagement.coBrokers,
	salesAgents: state.siteplanManagement.salesAgents,
	lots: state.siteplanManagement.lots,
});

export default connect(mapStateToProps)(CoBroker);
